import angular from 'angular';
import { IFormModel } from '../form-controller';
import { ThemeServiceType } from '@Shared.Angular/flowingly.services/themeService';

angular.module('fg').directive('fgFormFields', [
  'fgConfig',
  'themeService',
  function (fgConfig, themeService: ThemeServiceType) {
    return {
      require: ['^?fgForm'],
      restrict: 'AE',
      templateUrl: 'angular-form-gen/form/form-fields/form-fields.ng.html',
      scope: {},
      link: function ($scope, $element, $attrs, ctrls) {
        const fgForm = ctrls[0];
        fgForm.model._fields = fgForm.flowFields; // We "merge" these relatively recently added fields to the existing model attribute*/
        fgForm.model.isWorkFlow = fgForm.isWorkflow;

        $scope.showDummyDoneButton = fgConfig.showDummyDoneButton;

        $scope.$watch(
          function () {
            return fgForm.model;
          },
          function (value: IFormModel) {
            $scope.form = value;
          }
        );
        $scope.$watch(
          function () {
            return $scope.$parent.fgTheme;
          },
          function (theme) {
            $scope.theme = theme;

            if (theme?.primaryButtonColor) {
              $scope.primaryButtonContrastColor = themeService.getContrastColor(
                theme.primaryButtonColor
              );
            } else {
              $scope.primaryButtonContrastColor = null;
            }
          }
        );
      }
    };
  }
]);
